import { Link } from 'react-router-dom';
import { HiMail, HiLocationMarker } from 'react-icons/hi';
import { FaLinkedin, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const footerLinks = {
        company: [
            { name: 'About VOE', href: '/about' },
            { name: 'Our Team', href: '/about' },
            { name: 'Contact', href: '/contact' },
        ],
        services: [
            { name: 'Audit & Assessment', href: '/audit' },
            { name: 'Products', href: '/products' },
            { name: 'The Seal & Directory', href: '/the-seal-voe-directory' },
        ],
        resources: [
            { name: 'Resources', href: '/resources' },
            { name: 'Q&A', href: '/qa' },
            { name: 'Workshops', href: '/dashboard/workshops' },
        ],
        legal: [
            { name: 'Privacy Policy', href: '/privacy' },
            { name: 'Terms & Conditions', href: '/terms' },
        ],
    };

    return (
        <footer className="bg-secondary-900 text-secondary-300">

            {/* CTA Section */}
            <div className="bg-gold-500">
                <div className="container-custom py-12">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                        <div>
                            <h3 className="text-2xl font-bold text-secondary-900">
                                Let's Talk? Register my Company!
                            </h3>
                            <p className="text-secondary-800 mt-1">
                                Start your journey to VFX operational excellence
                            </p>
                        </div>
                        <Link
                            to="/register"
                            className="btn bg-secondary-900 text-white hover:bg-black shadow-lg"
                        >
                            Get Started
                        </Link>
                    </div>
                </div>
            </div>

            {/* Main footer */}
            <div className="container-custom py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">

                    {/* Brand column */}
                    <div className="lg:col-span-2">
                        <Link to="/" className="inline-block mb-6">
                            <img
                                src="/logos/Logo_Black_transparent.png"
                                alt="VOE Standard"
                                className="h-10 w-auto"
                            />
                        </Link>

                        <p className="mt-4 text-sm leading-relaxed">
                            VOE Standard sets the benchmark for operational excellence in VFX outsourcing.
                            We certify and elevate mature VFX vendors through a rigorous label of excellence.
                        </p>

                        {/* Social links */}
                        <div className="mt-6 flex gap-4">
                            <a
                                href="https://www.linkedin.com/company/108947596"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="p-2 rounded-lg bg-secondary-800 hover:bg-secondary-700 transition-colors"
                            >
                                <FaLinkedin className="w-5 h-5" />
                            </a>

                            <a
                                href="#"
                                className="p-2 rounded-lg bg-secondary-800 hover:bg-secondary-700 transition-colors"
                            >
                                <FaXTwitter className="w-5 h-5" />
                            </a>

                            <a
                                href="#"
                                className="p-2 rounded-lg bg-secondary-800 hover:bg-secondary-700 transition-colors"
                            >
                                <FaYoutube className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    {/* Links columns */}
                    <div>
                        <h4 className="text-white font-semibold mb-4">Company</h4>
                        <ul className="space-y-2">
                            {footerLinks.company.map((link) => (
                                <li key={link.name}>
                                    <Link
                                        to={link.href}
                                        className="text-sm hover:text-white transition-colors"
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-4">Services</h4>
                        <ul className="space-y-2">
                            {footerLinks.services.map((link) => (
                                <li key={link.name}>
                                    <Link
                                        to={link.href}
                                        className="text-sm hover:text-white transition-colors"
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-4">Resources</h4>
                        <ul className="space-y-2">
                            {footerLinks.resources.map((link) => (
                                <li key={link.name}>
                                    <Link
                                        to={link.href}
                                        className="text-sm hover:text-white transition-colors"
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            {/* Bottom bar */}
            <div className="border-t border-secondary-800">
                <div className="container-custom py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-sm">
                            © VFX OPERATIONAL EXCELLENCE {currentYear} | All Rights Reserved
                        </p>

                        <div className="flex gap-6 text-sm">
                            {footerLinks.legal.map((link) => (
                                <Link
                                    key={link.name}
                                    to={link.href}
                                    className="hover:text-white transition-colors"
                                >
                                    {link.name}
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;